const style = {
  pageTitleWrapper: {
    borderLeft: `10px solid #2470AC`,
  },
  tabPaper: {
    backgroundColor: "grey.50",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  tablePaper: {
    borderRadius: 1,
  },
  disabledButton: {
    "&.Mui-disabled": {
      pointerEvents: "auto",
    },
  },
  failoverEnded: {
    backgroundColor: "rgb(240,252,239)",
    "& .MuiTypography-root": { color: "green !important" },
  },
  failoverTriggered: {
    backgroundColor: "rgb(255,240,240)",
    "& .MuiTypography-root": { color: "red !important" },
  },
  dialogContent: {
    width: "370px",
    padding: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    borderBottom: "1px solid",
    borderColor: "grey.300",
  },
  dialogTitle: {
   marginTop:"8px",
   marginLeft:"32px",
    padding: "4px",
  },
  heading: {
    marginTop: "4px",
    paddingLeft:"4px",
    marginBottom: "8px",
  },
  actions: {
    padding: 2,
    justifyContent: "center",
  },
  infoBtn: {
    marginTop: "14px",
    width: "120px",
    height: "140px",
  },
  actionButtons: {
    width: "140px",
    padding: "6px",   
  },
};

export default style;
